import {Locale} from '@aboutyou/config';
import {LogoIconName} from '../assets';

export const getWoohooCampaignLogo = (locale: Locale) => {
  switch (locale) {
    case Locale.lt_LT:
      return LogoIconName.CampaignLogoLT;
    case Locale.lv_LV:
      return LogoIconName.CampaignLogoLV;
    case Locale.it_IT:
      return LogoIconName.CampaignLogoIT;
    case Locale.pl_PL:
      return LogoIconName.CampaignLogoPL;
    case Locale.sl_SI:
    default:
      return LogoIconName.CampaignLogo;
  }
};
